import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { AddDispatchEvent } from './adddispatchevent';

import { DispatchEventDetailsBody } from './dispatcheventdetailsview';

import { BillExportSettingsView } from 'portcall/billexportsettings/view';
import { PCModal } from 'portcall/pcmodal/view';

export const AddDispatchEventView = SuperCritical(({ modelContainer } : { modelContainer : () => AddDispatchEvent | null }) => {
    const m = modelContainer();
    return (
        <PCModal className="adddispatchevent" shown={() => !!m} onBackDropClick={m?.Cancel}>
            <div className="modal-content pc-card">
                <div className="pc-card-header pc-card-title">Add Event</div>
                {m &&
                    <form className="modal-body">
                        <DispatchEventDetailsBody event={m.Model}
                            canEdit={() => true}
                            validation={m.Validation}
                            localization={m.Localization} />
                        {m.CanManageBills() &&
                            <BillExportSettingsView model={m.BillExportSettings} />
                        }
                        <div className="buttons">
                            <a href="" className="cancel-btn" onClick={noDefault(m.Cancel)}>Cancel</a>
                            <button className="submit-btn pc-button pc-button-primary" onClick={noDefault(m.AddDispatchEvent)}>Submit</button>
                        </div>
                    </form>
                }
            </div>
        </PCModal>
    );
});


// WEBPACK FOOTER //
// ./apps/pilots/dispatchdashboard/adddispatcheventview.tsx